export default __webpack_public_path__ + "static/media/eu.6c47dff2.png";